// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1BGwf","avatar":"style_avatar__2VMYV"};